import { PageLoading } from '@/components/page-loading'
import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { ContentLayout } from '../content-layout'

export const NormalLayout = () => (
  <ContentLayout menuList={[]} showDescribe={false}>
    <Suspense fallback={<PageLoading />}>
      <Outlet />
    </Suspense>
  </ContentLayout>
)
